import { LoginImage } from "./LoginImage"
import { LoginContent } from "./LoginContent"

type Props = {
  switchToSignup?: () => void
  onLogin?: () => void
  shouldRedirect?: boolean
}

const LoginForm = ({ switchToSignup, onLogin, shouldRedirect }: Props = {}) => {
  return (
    <div className="flex rounded-xl p-0">
      <LoginImage />
      <LoginContent onSwitchToSignup={switchToSignup} onLogin={onLogin} shouldRedirect={shouldRedirect} />
    </div>
  )
}

export default LoginForm
